import dayjs from "dayjs";
import { EventType } from "../components/Shared/Schedule/Schedule";
import { JOB_STATUS } from "../configs/constants/JobStatus";
import { TIME_REPORT_STATUS } from "../configs/constants/TimeReportStatus";
import { Application, JobShift } from "../models/Job";
import TimeReport from "../models/TimeReport";
import isoWeek from "dayjs/plugin/isoWeek";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
// import { Absences } from "../models/Consultant";

dayjs.extend(isoWeek);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

// interface AbsencesWithConsultantId extends Absences {
// 	consultantId: string;
// }

export function getEventTypeForJobStatus(
	status: JOB_STATUS,
	shift?: JobShift,
	acceptedApplicationForShift?: Application
): EventType {
	// switch (status) {
	// 	case JOB_STATUS.OPEN:
	// 	case JOB_STATUS.BOOKED_WITH_UNMANNED_SHIFTS:
	// 	default:
	// 		if (shift?.status === "EXTEND_REQUESTED" && !acceptedApplicationForShift) {
	// 			return "shift-extend-requested";
	// 		} else if (
	// 			shift &&
	// 			shift.start &&
	// 			shift.end &&
	// 			acceptedApplicationForShift?.consultant.absences?.length
	// 		) {
	// 			const absenceList = acceptedApplicationForShift.consultant.absences;
	// 			const hasAbsentShift = absenceList.find((ab) =>
	// 				isDateRangeWithin(
	// 					ab.startDate,
	// 					ab.endDate,
	// 					dayjs(shift.start).format(),
	// 					dayjs(shift.end).format()
	// 				)
	// 			);
	// 			if (hasAbsentShift) return "absence";
	// 		}
	// 		return acceptedApplicationForShift ? "shift-booked" : "shift-open";
	// 	case JOB_STATUS.BOOKED:
	// 		return "shift-booked";
	// 	case JOB_STATUS.DELETED:
	// 	case JOB_STATUS.CANCELLED:
	// 		return "shift-cancelled";
	// 	case JOB_STATUS.DECLINED:
	// 		return "shift-declined";
	// }
	if (shift?.status === "EXTEND_REQUESTED" && !acceptedApplicationForShift) {
		return "shift-extend-requested";
	}
	if (
		shift &&
		shift.start &&
		shift.end &&
		acceptedApplicationForShift?.consultant.absences?.length &&
		[JOB_STATUS.OPEN, JOB_STATUS.BOOKED_WITH_UNMANNED_SHIFTS].includes(status)
	) {
		const absenceList = acceptedApplicationForShift.consultant.absences;
		const hasAbsentShift = absenceList.find((ab) =>
			isDateRangeWithin(
				ab.startDate,
				ab.endDate,
				dayjs(shift.start).format(),
				dayjs(shift.end).format()
			)
		);
		if (hasAbsentShift) return "absence";
	}
	if (
		shift &&
		shift.start &&
		shift.end &&
		acceptedApplicationForShift?.consultant.absences?.length
	) {
		const absenceList = acceptedApplicationForShift.consultant.absences;
		const hasAbsentShift = absenceList.find((ab) =>
			isDateRangeWithin(
				ab.startDate,
				ab.endDate,
				dayjs(shift.start).format(),
				dayjs(shift.end).format()
			)
		);
		if (hasAbsentShift) return "absence";
	}
	if (status === JOB_STATUS.BOOKED) return "shift-booked";
	if ([JOB_STATUS.CANCELLED, JOB_STATUS.DELETED].includes(status)) return "shift-cancelled";
	if (status === JOB_STATUS.DECLINED) return "shift-declined";
	if (shift?.status === "EXTEND_REQUESTED" && !acceptedApplicationForShift) {
		return "shift-extend-requested";
	}
	return acceptedApplicationForShift ? "shift-booked" : "shift-open";
}

export function getEventTypeForTimeReport(timeReport: Pick<TimeReport, "status">): EventType {
	switch (timeReport.status) {
		case TIME_REPORT_STATUS.NOT_WORKED:
		case TIME_REPORT_STATUS.PENDING:
		default:
			return "time-report-pending";
		case TIME_REPORT_STATUS.ATTESTED_BY_CUSTOMER:
		case TIME_REPORT_STATUS.ATTESTED_BY_ADMIN:
		case TIME_REPORT_STATUS.INVOICED:
		case TIME_REPORT_STATUS.RESOLVED_DECLINE_BY_ADMIN:
		case TIME_REPORT_STATUS.WORKED:
			return "time-report-reported";
		case TIME_REPORT_STATUS.DECLINED_BY_CUSTOMER:
			return "time-report-declined";
	}
}

export function getStartEndFromQuery(query: URLSearchParams) {
	if (query.has("start") && query.has("end")) {
		return {
			startDate: dayjs(query.get("start")).toDate(),
			endDate: dayjs(query.get("end")).toDate(),
		};
	} else if (query.has("period")) {
		if (query.get("period") === "week") {
			return {
				startDate: dayjs(dayjs().startOf("isoWeek")).toDate(),
				endDate: dayjs(dayjs().endOf("isoWeek")).toDate(),
			};
		} else if (query.get("period") === "month") {
			return {
				startDate: dayjs(dayjs().startOf("month")).toDate(),
				endDate: dayjs(dayjs().endOf("month")).toDate(),
			};
		}
	}
	return {
		startDate: dayjs().startOf("month").toDate(),
		endDate: dayjs().endOf("month").toDate(),
	};
}

export function getDates(startDate: Date, endDate: Date): { start: Date; end: Date }[] {
	const dates: { start: Date; end: Date }[] = [];

	let currentDate = dayjs(startDate);
	const end = dayjs(endDate);

	while (currentDate.isBefore(end) || currentDate.isSame(end)) {
		dates.push({
			start: currentDate.startOf("date").toDate(),
			end: currentDate.endOf("date").toDate(),
		});
		currentDate = currentDate.add(1, "day");
	}

	return dates;
}

export const isDateRangeWithin = (
	haystackStart: string,
	haystackEnd: string,
	needleStart: string,
	needleEnd: string
): boolean => {
	const startDateHaystack = dayjs(haystackStart);
	const endDateHaystack = dayjs(haystackEnd);
	const startDateNeedle = dayjs(needleStart);
	const endDateNeedle = dayjs(needleEnd);

	return (
		startDateNeedle.isSameOrAfter(startDateHaystack) &&
		endDateNeedle.isSameOrBefore(endDateHaystack)
	);
};
